/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentAssessment from './treatment-assessment';
import TreatmentAssessmentDetail from './treatment-assessment-detail';
import TreatmentAssessmentUpdate from './treatment-assessment-update';
import TreatmentAssessmentDeleteDialog from './treatment-assessment-delete-dialog';

const TreatmentAssessmentRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentAssessment />} />
    <Route path="new" element={<TreatmentAssessmentUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentAssessmentDetail />} />
      <Route path="edit" element={<TreatmentAssessmentUpdate />} />
      <Route path="delete" element={<TreatmentAssessmentDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentAssessmentRoutes;
